import React, { useState, createRef, useEffect } from "react";
import { useLocation } from "@reach/router";
import { useSubstrate } from "./substrate-lib";
import { Button, Col, Row, Table } from "antd";
import "antd/dist/antd.css";
import { ToastProvider, useToasts } from "react-toast-notifications";
import { parse } from "query-string";
import { ArrowDownOutlined } from "@ant-design/icons";
import { fetchAPI } from "./utils/fetchUtil";
import backgroundImageOne from "./assets/images/Continuum3-min.png";
import SocialLinks from "./SocialLinks";

export default function PublicEvent(props) {
  return (
    <ToastProvider autoDismiss>
      <div className="title-header">
        <h2>
          Stay on top of Metaverse Network - Bit.Country's upcoming Metaverse Odyssey Public Event.
        </h2>
      </div>
      <Row>
        <Col span={24} style={{ margin: "auto" }}>
          <div className="signup-wrapper">
            <iframe
              frameborder="0"
              style={{ height: 1000, width: "100%", border: "none" }}
              src="https://forms.zohopublic.com/industryconnect/form/ExpressionofInterestsforMetaverseOdysseyPublicEven/formperma/JcS6ss0dQap9H46hs5mAsmmpykgUmBjb00XLsdLPM0M"
            ></iframe>
          </div>
        </Col>
      </Row>
    </ToastProvider>
  );
}

export function JoinNewLetterButton(props) {
  const { addToast } = useToasts();

  return (
    <Button
      className="primary-button"
      type="primary"
      onClick={() => {
        addToast(
          "We just sent you the confirmation email, please click the confirmation email to verify",
          { appearance: "success" }
        );
      }}
    >
      Join
    </Button>
  );
}
